import { Table, Select, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth.js";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import "antd/dist/antd.min.css";
import { AssignToTagger, PriprityLevel } from "../utilities/Assignto.js";
import usePageVisibility from "../utilities/usePageVisibility";
import { redirect, useLocation } from "react-router-dom";
import axiosInstance from '../utilities/axiosInstance';
import { useWindowManager } from './../hooks/useWindowManager';
import "../styles/profileDetails.scss"
import { showAlert } from "./AlertPopup";

const TaggerData = () => {
  const { Option } = Select;
  const { auth } = useAuth();
  const taggerId =
    auth.profile_username === "admin" ? auth.profile_username : auth.profile_id;
  const [data, setData] = useState([]);
  const [portNumber, setPortNumber] = useState();
  let currentURL = window.location.href;
  let porturl = new URL(currentURL);
  let appPort = porturl.port;
  const [finalData, setFinalData] = useState([]);
  let location = useLocation();
  const [searchValue, setSearchValue] = useState('');
  const urlParams = new URLSearchParams(window.location.search);
  const projectId = urlParams.get('project_id');
  const [taggers, setTaggers] = useState([]);
  const { redirectToTagging } = useWindowManager();

  const columnsRow = [
    {
      title: (
        <Tooltip title="Created Date">
          <span>Date</span>
        </Tooltip>
      ),
      dataIndex: "createdDate",
      key: "createdDate",
      fixed: "left",
      render: (date) => new Date(date).toLocaleDateString()
    },
    {
      title: (
        <Tooltip title="Folder Title">
          <span>Folder</span>
        </Tooltip>
      ),
      dataIndex: "task_folder_name",
      key: "taskFolderName",
      width: 180,
      render: (text) => (
        <Tooltip title={text}>
          <div style={{
            width: '200px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {text}
          </div>
        </Tooltip>
      )
    },
    {
      title: (
        <Tooltip title="Assign To">
          <span>Assign To</span>
        </Tooltip>
      ),
      dataIndex: "profile_username",
      key: "profileUsername",
      render: (text, record, pname) => (
        <AssignToSelect pname={pname} record={record} />
      ) 
    },
    {
      title: (
        <Tooltip title="No Of Items">
          <span>Items</span>
        </Tooltip>
      ),
      dataIndex: "task_filename",
      key: "noOfItems",
      render: (text, record) => {
        try {
          let numItems =
            record.numimage > 0
              ? record.numimage
              : record.numvideos > 0
                ? record.numvideos
                : record.numdocs;

          return (
            <button
              onClick={() => redirectToTagging(record.profile_id, record.task_mediatype, taggerId, auth)}
              className="h-8 w-8 rounded-full bg-[#0fb4d2] text-white text-xs flex items-center justify-center cursor-pointer"
            >
              {numItems}
            </button>
          );
        } catch (error) {
          console.error("Error rendering number of images:", error);
          return 0; // or display an error message
        }
      },
    },

    {
      title: (
        <Tooltip title="Upload Type">
          <span>Upload</span>
        </Tooltip>
      ),
      dataIndex: "task_process_type",
      key: "taskProcessType",
    },
    {
      title: (
        <Tooltip title="Labeled Type">
          <span>Labeled</span>
        </Tooltip>
      ),
      dataIndex: "labeledType",
      key: "labeledType"
    },
    {
      title: (
        <Tooltip title="Media Type">
          <span>Media</span>
        </Tooltip>
      ),
      dataIndex: "task_mediatype",
      key: "taskMediatype",
    },

    {
      title: (
        <Tooltip title="Status">
          <span>Status</span>
        </Tooltip>
      ),
      dataIndex: "task_status",
      key: "taskStatus",
      render: (text, record) => <StatusSelect record={record} />,
    },
    {
      title: (
        <Tooltip title="Priority Level">
          <span>Priority</span>
        </Tooltip>
      ),
      dataIndex: "task_prioroty",
      key: "priorotyLevel",
      render: (text, record) =>
        auth.profile_role === 1 || auth.profile_role === 2 ? (
          <PriprityLevel record={record} />
        ) : (
          record.task_prioroty
        ),
    },
    {
  title: (
    <Tooltip title="Progress">
      <span>Progress</span>
    </Tooltip>
  ),
  dataIndex: "progress",
  key: "progress",
  render: (text, record) => {
    let numerator = 0;
    let denominator = 0;

    if (record.task_mediatype === "image") {
      numerator = record.labeledImages || 0;
      denominator = record.totalImages || 0;
    } else if (record.task_mediatype === "doc") {
      numerator = record.labeledDoc || 0;
      denominator = record.totalDoc || 0;
    }

    return (
      <span>
        {numerator} / {denominator}
      </span>
    );
  }
}

  ];

  const StatusSelect = ({ record }) => {
    const [taskStatus, setTaskStatus] = useState({});
    const [data, setData] = useState([]);

    useEffect(() => {
      setTaskStatus((prevState) => ({
        ...prevState,
        [record.task_id]: record.task_status || "Todo",
      }));
    }, [record]);

    const [completedTaskIds, setCompletedTaskIds] = useState([]);

    const handleStatusChange = (value) => {
      record.task_status = value;
      const updatedTaskStatus = { ...taskStatus, [record.task_id]: value };
      setTaskStatus(updatedTaskStatus);
      if (value === "Completed") {
        setCompletedTaskIds([...completedTaskIds, record.task_id]);
      }

      // Update the task status in the backend
      axiosInstance
        .put(`/updatetask/${record.task_id}`, {
          record: {
            ...record,
            task_status: value,
            reviewer_task_status:
              value === "Done" ? "Waiting for review" : null,
          },
        })
        .then((response) => {
          showAlert(response.data.message, 'success');
          // Remove the completed task from the tagger list
          const updatedData = data.filter(
            (task) => task.task_id !== record.task_id
          );
          setData(updatedData);
        })
        .catch((error) => console.error(error));
    };

    return (
      <Select
        value={taskStatus[record.task_id]}
        style={{ width: 120 }}
        onChange={handleStatusChange}
      >
        <Option value="Reassigned" disabled>
          reassigned
        </Option>
        <Option value="Processed">In Process</Option>
        <Option value="Completed" disabled>
          Completed
        </Option>
        <Option value="Done" disabled>
          Task done
        </Option>
      </Select>
    );
  };

  const AssignToSelect = ({ record }) => {

    const handleAssignToChange = async (value) => {
      let taskId = record.task_id;
      let newProfileId = value;

      try {
        const res = await axiosInstance.put(
          `/tasks/${taskId}/tagger`,
          { newProfileId },
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
          }
        );
        getTaggers();
      } catch (err) {
        console.error("Failed to update tagger", err);
      }
    };

    return (
      <Select
        value={record.profile_username}
        style={{ width: 200 }}
        onChange={handleAssignToChange}
      >
        {
          taggers.map((tagger) =>
            <Option value={tagger.profile_id} key={tagger.profile_id} >
              {tagger.profile_username}
            </Option>)
        }
      </Select>
    );
  };

  const showCustomeAlert = (error) => {
    Swal.fire({
      title: "",
      text: error,
      icon: "Record added successfully...",
      confirmButtonText: "OK",
    });
  };
  useEffect(() => {
    if (searchValue !== "") {
      const newData = data.filter((item) => {
        return item.profile_email
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setFinalData(newData);
    } else {
      setFinalData(data);
    }
  }, [searchValue]);

  const getTaggers = () => {
      axiosInstance
        .get(`/gettaggertask`, {
          params: {
            profile_id: auth.profile_id,
            profile_role: auth.profile_role,
            project_id: projectId
          },
        })
        .then((response) => {
          let taggerTasks = response.data;
          setData(taggerTasks);
          setFinalData(taggerTasks);
        })
        .catch((error) => console.error(error));
  };

  useEffect(() => {
    getTaggers();
  }, [auth, projectId]);

  usePageVisibility(() => {
    const getTaggers = () => {
      axiosInstance
        .get(`/gettaggertask`, {
          params: {
            profile_id: auth.profile_id,
            profile_role: auth.profile_role,
            project_id: projectId
          },
        })
        .then((response) => {
          let taggerTasks = response.data;
          setData(taggerTasks);
          setFinalData(taggerTasks);
        })
        .catch((error) => console.error(error));
    };
    getTaggers();
  });

  useEffect(() => {
    const fetchTaggers = async () => {
      try {
        const token = localStorage.getItem("token"); // assuming JWT stored here
        const response = await axiosInstance.get(
          `/projects/${projectId}/taggers`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setTaggers(response.data);
      } catch (err) {
        console.error("Error fetching taggers:", err);
      }
    };

    if (projectId) {
      fetchTaggers();
    }
  }, [projectId]);

  return (
    <div>
      {/* <div>
        <SearchBar setSearchValue={setSearchValue}/>
      </div> */}
      <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 border-b border-gray-d-200 dark:text-white dark:border-white mb-[20px]">Welcome {(auth.profile_name !== 'null') ? auth.profile_name : auth.profile_username} - Tagger Page</h2>
      <div style={{ width: '100%', overflow: 'hidden' }}>
        <Table
          className="details-view-table"
          //rowSelection={rowSelection}
          columns={columnsRow}
          dataSource={finalData}
          pagination={{ pageSize: 6 }}
        // scroll={{ x: 400 }}
        />
      </div>
    </div>
  );
};

export default TaggerData;
